import { useSearchParams } from 'react-router-dom';
import KakaoEmailCollect from '@/components/auth/KakaoEmailCollect';

export default function CollectEmail() {
  const [params] = useSearchParams();
  const pendingId = params.get('pending') ?? '';

  if (!pendingId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Invalid link. Please sign in again.</p>
      </div>
    );
  }

  return <KakaoEmailCollect pendingId={pendingId} />;
}
